import { render, staticRenderFns } from "./labelManageDialog.vue?vue&type=template&id=39746814&"
import script from "./labelManageDialog.vue?vue&type=script&lang=js&"
export * from "./labelManageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports